/* Shiro Drip — selector de packs en la ficha de producto */
if (!customElements.get('bundle-builder')) {
  customElements.define(
    'bundle-builder',
    class BundleBuilder extends HTMLElement {
      connectedCallback() {
        this.tiers = Array.from(this.querySelectorAll('[data-bundle-tier]'));
        this.radios = Array.from(this.querySelectorAll('[data-bundle-radio]'));
        this.picker = this.querySelector('[data-bundle-picker]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.texts = JSON.parse(this.querySelector('[data-bundle-texts]').textContent);

        if (!this.tiers.length) return;

        this.activeSlot = null;
        this.lastFocused = null;

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.selectTier(radio.value));
        });

        // Abrir el selector de producto desde una ranura vacía o para cambiarla
        this.addEventListener('click', (event) => {
          const chooseButton = event.target.closest('[data-bundle-choose]');
          if (chooseButton) {
            event.preventDefault();
            this.openPicker(chooseButton.closest('[data-bundle-slot]'), chooseButton);
            return;
          }

          const pick = event.target.closest('[data-bundle-pick]');
          if (pick) {
            event.preventDefault();
            this.applyPick(pick.closest('[data-bundle-option]'));
          }
        });

        if (this.picker) {
          this.picker.querySelectorAll('[data-bundle-close]').forEach((el) => {
            el.addEventListener('click', () => this.closePicker());
          });
        }

        this.onKeydown = (event) => {
          if (event.key === 'Escape' && this.picker && !this.picker.hidden) this.closePicker();
        };
        document.addEventListener('keydown', this.onKeydown);

        // Intercepta el envío del formulario de producto antes que el tema
        this.form = document.getElementById(this.dataset.formId) || null;
        this.onSubmit = (event) => {
          if (!this.form || event.target !== this.form) return;
          event.preventDefault();
          event.stopPropagation();
          this.addBundle();
        };
        document.addEventListener('submit', this.onSubmit, true);

        const checked = this.radios.find((radio) => radio.checked) || this.radios[0];
        if (checked) {
          checked.checked = true;
          this.selectTier(checked.value);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.onSubmit, true);
        document.removeEventListener('keydown', this.onKeydown);
      }

      currentTier() {
        const checked = this.radios.find((radio) => radio.checked);
        return checked ? this.querySelector('[data-bundle-tier="' + checked.value + '"]') : null;
      }

      quantity() {
        const tier = this.currentTier();
        return tier ? parseInt(tier.dataset.bundleQuantity, 10) || 1 : 1;
      }

      selectTier(value) {
        this.tiers.forEach((tier) => {
          tier.classList.toggle('is-selected', tier.dataset.bundleTier === value);
        });
        this.hideError();

        // Con packs de 2 o 3 la cantidad la fija el pack, no el selector del tema
        const quantityWrapper = document.querySelector('.product-form__quantity');
        if (quantityWrapper) quantityWrapper.hidden = this.quantity() > 1;
      }

      openPicker(slot, trigger) {
        if (!this.picker || !slot) return;
        this.activeSlot = slot;
        this.lastFocused = trigger || null;
        this.picker.hidden = false;
        document.body.style.overflow = 'hidden';
        const close = this.picker.querySelector('[data-bundle-close]');
        if (close) close.focus();
      }

      closePicker() {
        if (!this.picker) return;
        this.picker.hidden = true;
        document.body.style.overflow = '';
        if (this.lastFocused) this.lastFocused.focus();
        this.activeSlot = null;
      }

      applyPick(option) {
        if (!option || !this.activeSlot) return;

        const select = option.querySelector('[data-bundle-variant]');
        const variantId = select ? select.value : option.dataset.bundleVariant;
        if (!variantId) return;

        const slot = this.activeSlot;
        slot.dataset.bundleFilled = 'true';

        const name = slot.querySelector('[data-bundle-slot-name]');
        if (name) name.textContent = option.dataset.bundleTitle;

        const media = slot.querySelector('[data-bundle-slot-media]');
        const image = option.dataset.bundleImage;
        if (media) {
          if (image) {
            media.outerHTML =
              '<img data-bundle-slot-media class="bundle__slot-thumb" src="' +
              image +
              '" alt="" width="64" height="64" loading="lazy">';
          } else {
            media.outerHTML = '<span data-bundle-slot-media class="bundle__slot-empty">+</span>';
          }
        }

        // Copia el desplegable de tallas del producto elegido a la ranura
        const slotSelect = slot.querySelector('[data-bundle-slot-variant]');
        if (slotSelect && select) {
          slotSelect.innerHTML = select.innerHTML;
          slotSelect.value = select.value;
          slotSelect.hidden = false;
        }

        const button = slot.querySelector('[data-bundle-choose]');
        if (button) {
          button.textContent = this.texts.change;
          button.classList.add('bundle__choose--ghost');
        }

        this.hideError();
        this.closePicker();
      }

      collect() {
        const tier = this.currentTier();
        if (!tier) return null;

        const items = [];
        const slots = Array.from(tier.querySelectorAll('[data-bundle-slot]'));

        for (let i = 0; i < slots.length; i++) {
          const slot = slots[i];
          const select = slot.querySelector('[data-bundle-slot-variant]');
          const id = select && !select.hidden ? select.value : null;
          if (!id) return null;
          items.push({ id: Number(id), quantity: 1 });
        }

        return items.length ? items : null;
      }

      showError(text) {
        if (!this.errorEl) return;
        this.errorEl.textContent = text;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (this.errorEl) this.errorEl.hidden = true;
      }

      addBundle() {
        const items = this.collect();

        if (!items) {
          this.showError(this.texts.incomplete);
          return;
        }

        const button = this.form ? this.form.querySelector('[type="submit"]') : null;
        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('loading');
          const spinner = button.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        // Si el tema tiene carrito lateral, lo abrimos en vez de ir a la página del carrito
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const payload = { items: items };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) throw new Error(data.description || data.message);

            if (cart && typeof cart.renderContents === 'function' && data.sections) {
              if (typeof cart.classList !== 'undefined') cart.classList.remove('is-empty');
              cart.renderContents(data);
              if (button) {
                button.removeAttribute('aria-disabled');
                button.classList.remove('loading');
                const done = button.querySelector('.loading__spinner');
                if (done) done.classList.add('hidden');
              }
              return;
            }

            window.location = window.Shopify.routes.root + 'cart';
          })
          .catch((error) => {
            this.showError(error.message || this.texts.failed);
            if (button) {
              button.removeAttribute('aria-disabled');
              button.classList.remove('loading');
              const spinner = button.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }
          });
      }
    }
  );
}
